"use client";

import { usePortalContext } from "@cloai/uikit";
import { useCallback } from "react";

import { PhotoSettings, useUndressContext } from "@/providers";

import { PORTALS } from ".constants/portals";

/**
 * Хук для обработки кликов по настройкам фото и открытия туториалов.
 * @returns Функция `handleItemClick`, которую можно передавать в `onClick`
 */
export const useClickSettings = () => {
  const { openPortal, closePortal } = usePortalContext();
  const {
    clickFileId,
    clickUndressingFile,
    onReUseFaceObj,
    reUseFaceObj,
    updatePhotoSetting,
  } = useUndressContext();

  /**
   * Обработчик клика по настройке фото.
   * @param itemType - Тип настройки (`quality`, `pose`, `costume` и т. д.)
   * @param itemId - ID выбранной настройки
   * @returns Функция обработчика `onClick`
   */
  const handleItemClick = useCallback(
    (itemType: keyof PhotoSettings, itemId: string) => async () => {
      updatePhotoSetting(clickFileId, itemType, itemId);
      closePortal();

      if (reUseFaceObj) {
        return onReUseFaceObj();
      }

      if (!clickUndressingFile) {
        return openPortal(PORTALS.USER_FLOW_UPLOAD);
      }
    },
    [
      clickFileId,
      clickUndressingFile,
      closePortal,
      onReUseFaceObj,
      openPortal,
      reUseFaceObj,
      updatePhotoSetting,
    ],
  );

  return handleItemClick;
};
